import React from 'react';
import "../../Style/Spamie.css"; // Import your custom styles here
import vector1 from '../../assests/Vector (1).png';
import vector2 from '../../assests/service/medium-shot-smiley-girl-with-stethoscope.jpg';
// import member from './assests/Group.png';
import icon1 from '../../assests/Ai.jpg';
import icon2 from '../../assests/medical data.jpg';
import icon3 from '../../assests/health care.jpg';
import icon4 from '../../assests/remote medicine.jpg';
import icon5 from '../../assests/doctor online.jpg';
import icon6 from '../../assests/BREAK CHIAN.jpg';
import {  FaShieldAlt, FaRobot, FaBell, FaChartLine, FaHeartbeat, FaFileMedical, FaVideo, FaClipboardCheck, FaPills, FaLock, FaFileContract, FaNetworkWired, FaLaptopMedical, FaUserMd } from "react-icons/fa";
import CompetitiveEdge from './Compitative';
import Teams from './Teams';
import Footer from '../../Component/Fooder';
// const PointerIcon = ({ fill, stroke, margin, year, arrow, arrow1, direction, text, position, y1, y2, direction1, position1, y11, y21 }) => {
//   const circleRadius = 12;
//   const lineHeight = 30;
//   const svgHeight = 100;
//   const extraCircleRadius = 18; // Adjust this radius as needed

//   return (
//     <div className='w-full xl:mt-12 md:w-20 sm:mr-0'>
//       <svg className='sm:w-16 sm:h-96 md:w-30 svg-container'
//         viewBox={`0 0 100 ${svgHeight}`}
//         xmlns="http://www.w3.org/2000/svg"
//         style={{ height: `200px`, marginTop: margin }}
//       >
//         <path
//           d={`M50 0
//             C70 0 90 20 90 40
//             C90 60 70 80 50 100
//             C30 80 10 60 10 40
//             C10 20 30 0 50 0
//             Z
//             M50 ${lineHeight}
//             C37 ${lineHeight} 25 27 25 40
//             C25 53 37 65 50 65
//             C63 65 75 53 75 40
//             C75 27 63 ${lineHeight} 50 ${lineHeight}
//             Z`}
//           fill={fill}
//           stroke={stroke}
//           strokeWidth="2"
//         />
//         <circle cx="50" cy="40" r="29" fill="white" />
//         <text x="50" y="45" fontSize="13" textAnchor="middle" fill="black" fontWeight="bold">{year} </text>
//         <line
//           x1="50"
//           y1={`${svgHeight}`}
//           x2="50"
//           y2={`${svgHeight + lineHeight}`}
//           stroke={stroke}
//           strokeWidth="2"
//           strokeDasharray="4,4"
//         />
//         <circle cx="50" cy={svgHeight + lineHeight + circleRadius} r={circleRadius} fill={fill} stroke={stroke} strokeWidth="1" />
//         <circle cx="50" cy={svgHeight + lineHeight + circleRadius} r={extraCircleRadius} fill="none" stroke={stroke} strokeWidth="2" />

//         {arrow && (
//           <>
//             <line
//               x1={position}
//               y1={y1}
//               x2={direction}
//               y2={y2}
//               stroke={stroke}
//               strokeWidth="5"
//               markerEnd="url(#arrowhead)"
//             />
//             <defs>
//               <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="0" refY="3.5" orient="auto">
//                 <polygon points="0 0, 10 3.5, 0 7" fill={stroke} />
//               </marker>
//             </defs>
//           </>
//         )}
//         {arrow1 && (
//           <>
//             <line
//               x1={position1}
//               y1={y11}
//               x2={direction1}
//               y2={y21}
//               stroke={stroke}
//               strokeWidth="5"
//               markerEnd="url(#arrowhead)"
//             />
//             <defs>
//               <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="0" refY="3.5" orient="auto">
//                 <polygon points="0 0, 10 3.5, 0 7" fill={stroke} />
//               </marker>
//             </defs>
//           </>
//         )}
//       </svg>
//       <div className="text-center font-bold" style={{ fontSize: '0.9rem', fontFamily: 'Poppins', }}>
//         {text}
//       </div>
//     </div>
//   );
// }

function Frame2() {
  return (
    <>
      {/* <div className="w-full rounded-sm bg-gradient-to-l from-[#78ffa5] to-[#2a627a] shadow-default dark:border-strokedark p-6 pt-15 "> */}
      <div className="w-full rounded-sm bg-white shadow-default  p-6 pt-15 ">

        <div className=" flex flex-col md:flex-row items-center drop-shadow-xl px-6 md:px-12 py-12  bg-opacity-70 rounded-3xl">
          {/* Left Section - Text Content */}
          <div className="w-full md:w-1/2 space-y-6">
            {/* <div className="text-start text-2xl font-bold text-[#2a627a] uppercase tracking-wide">
            
          </div> */}
            <div className="text-start text-xl font-bold text-gray-800 leading-snug">
              Empowering <span className="text-[#2a627a] font-bold">Healthcare</span> Through Innovation
            </div>
            <p className="text-gray-800  leading-relaxed">
              At <span className="font-bold text-[#2a627a]">HIKEHEALTH GS</span>, we are dedicated to transforming healthcare through <span className="text-[#2a627a]  font-bold">cutting-edge technology</span> and innovative solutions. Our goal is to streamline medical processes, enhance patient care, and empower healthcare providers.
            </p>
            <p className="text-gray-800  leading-relaxed">
              We specialize in <span className="text-[#2a627a] font-bold">Electronic Health Records (EHR)</span>, <span className="text-[#2a627a] font-bold">Telemedicine Integration</span>, and <span className="text-[#2a627a] font-bold">Patient Management Platforms</span>. Our customized solutions help hospitals, clinics, and healthcare providers optimize workflows and improve patient outcomes.
            </p>
            <p className="text-gray-800  leading-relaxed">
              With a passionate team of <span className="font-bold text-[#2a627a]">45+ Healthcare Experts</span>, we envision a future where technology seamlessly integrates with healthcare to enhance lives.
            </p>

            {/* Stats Box */}
            <div className="flex items-center bg-[#2a627a] border border-green-400 rounded-2xl p-4 shadow-lg w-fit">
              <img draggable={false}src={vector1} alt="Healthcare Experts" className="w-12 h-12 mr-3" />
              <span className="text-xl font-semibold text-green-400 flex items-center">
                45+ <span className=" text-white ml-2">Healthcare Experts</span>
              </span>
            </div>

          </div>

          {/* Right Section - Image with Overlay */}
          <div className="w-full md:w-1/2 flex justify-center mt-8 md:mt-0 relative group">
            <div className="absolute inset-0  bg-white opacity-10  rounded-3xl"></div>
            <img
              src={vector2}
              alt="Healthcare Team"
              className="z-10  rounded-ee-full rounded-tl-full    border-t-4 border-b-4 border-[#2a627a] shadow-3xl  drop-shadow-2xl"
            />
          </div>
        </div>
        {/* Box method */}
        <div className="flex flex-col lg:flex-row gap-4 lg:gap-8 w-full lg:w-auto  transition-all duration-500 transform">
          {/* Healthcare IT Solutions */}
          <div className="flex flex-col items-center w-full lg:w-1/3">
            <div className="buttons border_bruh  bg-opacity-20 relative flex flex-col p-4 lg:p-6 w-full h-full shadow-lg hover:shadow-xl transition duration-300 transform hover:scale-105">
              <div className=" flex self-center w-12 h-12 lg:w-16 lg:h-16 text-blue-500">
                {/* <FaHospital className="w-full h-full" /> */}
                <img draggable={false}src={icon3} className="w-full h-full border-[#2a627a] border-4 rounded-lg drop-shadow-xl" alt="Icon 1" />
              </div>

              <div className="m-2  text-center text-lg font-bold  text-gray-800">
                Healthcare IT Solutions
              </div>

              <span className="text-center text-sm  text-gray-800">
                Empowering hospitals with advanced IT solutions for seamless patient care.
              </span>

              {/* Extra Features */}
              <div className="mt-2 space-y-2 text-xs  text-gray-800">
                <div className="flex items-center gap-2">
                  <FaLaptopMedical className="text-blue-500" /> Integrated EHR Systems
                </div>
                <div className="flex items-center gap-2">
                  <FaUserMd className="text-green-500" /> Telemedicine Platforms
                </div>
                <div className="flex items-center gap-2">
                  <FaHeartbeat className="text-red-500" /> Automated Workflow Management
                </div>
              </div>

              {/* CTA */}
              {/* <button className="mt-4 bg-blue-500 text-gray-800 px-4 py-2 rounded-lg hover:bg-blue-600 transition duration-300">
        Learn More
      </button> */}
            </div>
          </div>
          {/* AI in Healthcare */}
          <div className="flex flex-col items-center w-full lg:w-1/3">
            <div className="buttons border_bruh bg-white relative flex flex-col p-4 lg:p-6 w-full h-full shadow-lg hover:shadow-xl transition duration-300 transform hover:scale-105">
              <div className=" flex self-center w-12 h-12 lg:w-16 lg:h-16 text-purple-500">
                {/* <FaRobot className="w-full h-full" /> */}
                <img draggable={false}src={icon1} className="w-full h-full border-[#2a627a] border-4 rounded-lg drop-shadow-xl" alt="Icon 1" />
              </div>

              <div className="m-2  text-center text-lg  font-bold  text-gray-800">
                AI in Healthcare
              </div>

              <span className=" text-center text-sm  text-gray-800">
                Enhancing diagnostics and treatment with AI-driven healthcare solutions.
              </span>

              {/* AI Features */}
              <div className="mt-2 space-y-2 text-xs text-gray-800">
                <div className="flex items-center gap-2">🤖 AI-powered Disease Prediction</div>
                <div className="flex items-center gap-2">📈 Machine Learning for Patient Monitoring</div>
                <div className="flex items-center gap-2">💬 AI Chatbots for Patient Support</div>
              </div>

              {/* CTA */}
              {/* <button className="mt-4 bg-purple-500 text-gray-800 px-4 py-2 rounded-lg hover:bg-purple-600 transition duration-300">
        Discover AI
      </button> */}
            </div>
          </div>

          {/* Medical Data Security */}
          <div className="flex flex-col items-center w-full lg:w-1/3">
            <div className="buttons border_bruh bg-white relative flex flex-col p-4 lg:p-6 w-full h-full shadow-lg hover:shadow-xl transition duration-300 transform hover:scale-105">
              <div className=" flex self-center w-12 h-12 lg:w-16 lg:h-16 text-green-500">
                {/* <FaShieldAlt className="w-full h-full" /> */}
                <img draggable={false}src={icon2} className="w-full h-full border-[#2a627a] border-4 rounded-lg drop-shadow-xl" alt="Icon 1" />
              </div>

              <div className="m-2 text-center text-lg  font-bold  text-gray-800">
                Medical Data Security
              </div>

              <span className=" text-center text-sm   text-gray-800">
                Protecting patient information with robust data security and compliance.
              </span>

              {/* Security Features */}
              <div className="mt-2 space-y-2 text-xs  text-gray-800">
                <div className="flex items-center gap-2">🔒 HIPAA & GDPR Compliance</div>
                <div className="flex items-center gap-2">🛡️ Advanced Encryption Methods</div>
                <div className="flex items-center gap-2">📊 Secure Cloud-Based Storage</div>
              </div>

              {/* CTA */}
              {/* <button className="mt-4 bg-green-500 text-gray-800 px-4 py-2 rounded-lg hover:bg-green-600 transition duration-300">
        Explore Security
      </button> */}
            </div>
          </div>
        </div>
        <div className="flex flex-col lg:flex-row gap-4 lg:gap-8 w-full  lg:w-auto  transition-all duration-500 transform">

          {/* Remote Patient Monitoring */}
          <div className="flex flex-col items-center w-full lg:w-1/3">
            <div className="buttons border_bruh bg-white relative flex flex-col p-4 lg:p-6 w-full h-full shadow-lg hover:shadow-xl transition duration-300 transform hover:scale-105">
              <div className=" flex self-center w-12 h-12 lg:w-16 lg:h-16 text-purple-500">
                {/* <FaRobot className="w-full h-full" /> */}
                <img draggable={false}src={icon4} className="w-full h-full border-[#2a627a] border-4 rounded-lg drop-shadow-xl" alt="Icon 1" />
              </div>

              <div className="m-2 text-center text-lg font-bold  text-gray-800">
                Remote Patient Monitoring
              </div>

              <span className=" text-center text-sm   text-gray-800">
                Real-time health monitoring for better patient outcomes.
              </span>

              {/* AI Features */}
              <div className="mt-2 space-y-2 text-xs  text-gray-800">
                <div className="flex items-center gap-2"><FaBell className="text-red-500" /> Smart Health Alerts</div>
                <div className="flex items-center gap-2"><FaChartLine className="text-blue-500" /> Predictive Analytics</div>
                <div className="flex items-center gap-2"><FaRobot className="text-purple-500" /> Virtual Health Assistant</div>
                <div className="flex items-center gap-2"><FaHeartbeat className="text-green-500" /> Wearable Device Integration</div>
                <div className="flex items-center gap-2"><FaFileMedical className="text-gray-500" /> Automated Health Reports</div>
              </div>

              {/* CTA */}
              {/* <button className="mt-4 bg-purple-500 text-gray-800 px-4 py-2 rounded-lg hover:bg-purple-600 transition duration-300">
        Discover AI
      </button> */}
            </div>
          </div>
          {/* Telemedicine Services */}
          <div className="flex flex-col items-center w-full lg:w-1/3">
            <div className="buttons border_bruh bg-white relative flex flex-col p-4 lg:p-6 w-full h-full shadow-lg hover:shadow-xl transition duration-300 transform hover:scale-105">
              <div className=" flex self-center w-12 h-12 lg:w-16 lg:h-16 text-purple-500">
                {/* <FaRobot className="w-full h-full" /> */}
                <img draggable={false}src={icon5} className="w-full h-full border-[#2a627a] border-4 rounded-lg drop-shadow-xl" alt="Icon 1" />
              </div>

              <div className="m-2  text-center text-base font-bold   text-gray-800">
                Telemedicine Services
              </div>

              <span className=" text-center text-sm   text-gray-800">
                Virtual healthcare services for seamless doctor-patient interactions.
              </span>

              {/* AI Features */}
              <div className="mt-2 space-y-2 text-sm  text-gray-800">
                <div className="flex items-center gap-2"><FaVideo className="text-blue-500" /> HD Video Consultations</div>
                <div className="flex items-center gap-2"><FaClipboardCheck className="text-green-500" /> AI Symptom Checker</div>
                <div className="flex items-center gap-2"><FaPills className="text-purple-500" /> E-Prescription Generation</div>
                <div className="flex items-center gap-2"><FaRobot className="text-red-500" /> 24/7 Virtual Assistants</div>
                <div className="flex items-center gap-2"><FaLock className="text-gray-500" /> Secure Medical Records Access</div>
              </div>

              {/* CTA */}
              {/* <button className="mt-4 bg-purple-500 text-gray-800 px-4 py-2 rounded-lg hover:bg-purple-600 transition duration-300">
        Discover AI
      </button> */}
            </div>
          </div>
          {/* Blockchain in Healthcare */}
          <div className="flex flex-col items-center w-full lg:w-1/3">
            <div className="buttons border_bruh bg-white relative flex flex-col p-4 lg:p-6 w-full h-full shadow-lg hover:shadow-xl transition duration-300 transform hover:scale-105">
              <div className=" flex self-center w-12 h-12 lg:w-16 lg:h-16 text-purple-500">
                {/* <FaRobot className="w-full h-full" /> */}
                <img draggable={false}src={icon6} className="w-full h-full border-[#2a627a] border-4 rounded-lg drop-shadow-xl" alt="Icon 1" />
              </div>

              <div className="m-2  text-center text-base font-bold  text-gray-800">
                Blockchain in Healthcare
              </div>

              <span className="text-center text-sm -sm text-gray-800">
                Ensuring transparency and security in healthcare data transactions.
              </span>

              {/* AI Features */}
              <div className="mt-2  space-y-2 text-sm  text-gray-800">
                <div className="flex items-center gap-2">
                  <FaShieldAlt className="text-red-500" /> Secure Health Data Transactions
                </div>
                <div className="flex items-center gap-2">
                  <FaClipboardCheck className="text-green-500" /> Tamper-proof Medical Records
                </div>
                <div className="flex items-center gap-2">
                  <FaPills className="text-purple-500" /> Decentralized Access Control
                </div>
                <div className="flex items-center gap-2">
                  <FaFileContract className="text-blue-500" /> Smart Contracts for Data Integrity
                </div>
                <div className="flex items-center gap-2">
                  <FaNetworkWired className="text-orange-500" /> Interoperability & Data Sharing
                </div>
              </div>

              {/* CTA */}
              {/* <button className="mt-4 bg-purple-500 text-white px-4 py-2 rounded-lg hover:bg-purple-600 transition duration-300">
        Discover AI
      </button> */}
            </div>
          </div>
        </div>
        <div><CompetitiveEdge /></div>
        <div><Teams /></div>

      </div>
      <Footer />
    </>
  );
}

export default Frame2;
